<template>
  <section class="user-dash__opes card">
    <div class="dashboard__content card-body d-flex px-lg-5">
      <h2 class="heading-secondary">{{ title }}</h2>
      <div class="card my-3" :class="{ 'ope-card--closed': mine }" v-for="(training, i) in trainings" :key="'training-' + i">
        <div class="card-body mx-lg-3">
          <TrainingHeader :training="training" :mine="mine" />
          <div class="collapse mt-4" :id="'ope2Details' + training.id">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-7">
                <div>
                  <h3 class="heading-secondary">Description</h3>
                  <div class="form-row mt-3">
                    <div class="col-sm mt-1 mt-sm-0 mt-md-1 mt-lg-0">
                      <p class="mb-1" v-html="training.description"></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dash-ope__prdt user-dash__prdt col-12 col-md-6 col-lg-5">
                <div class="mt-4 mt-md-0">
                  <h3 class="heading-secondary">Lieu</h3>
                  <div class="prdt-card row">
                    <div class="prdt-card__details col m-0">
                      <p>{{ training.address }}</p>
                    </div>
                  </div>
                </div>
                <div class="mt-4 mt-md-0">
                  <h3 class="heading-secondary">Responsable Formation</h3>
                  <div class="prdt-card row">
                    <div class="prdt-card__details col m-0">
                      <p>{{ training.session_manager }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TrainingHeader from './TrainingHeader'

export default {
  name: 'TrainingSection',
  components: {
    TrainingHeader
  },
  props: {
    title: String,
    trainings: {
      type: Array,
      default: () => []
    },
    mine: Boolean
  }
}
</script>
